import React, { Component } from 'react'
import { isCorpOrGoPayUser } from '../../helper'
import { apiConstants } from '../../constants/apiConstants'
import { Message } from '@paypalcorp/worldready-react'

class Footer extends Component {
  constructor(props, context) {
    super(props, context)
  }

  showFeedBackForm = () => {
    window.open(apiConstants.FeedBackURL, '_blank')
  }

  navigateToHelpPage = () => {
    this.props.history.push(`${apiConstants.URLPrefix}${apiConstants.Help}`)
    this.props.setActiveMenu('help')
  }

  render() {
    const { user, isUserLoggedout } = this.props
    return (
      <div className="vx_globalFooter">
        <div className="vx_globalFooter-content">
          <ul className="vx_globalFooter-list">
            {isUserLoggedout ? (
              ''
            ) : (
              <li className="footer__options">
                <a
                  data-pa-pgrp={`dropzone:${user.accType}`}
                  data-pa-page={`dropzone:help:${user.accType}`}
                  data-pa-click="help"
                  onClick={() => this.navigateToHelpPage()}
                >
                  <Message id="footer.helpMenu" />
                </a>
              </li>
            )}
            {isCorpOrGoPayUser(user) && (
              <li className="footer__options">
                <a
                  data-pa-pgrp={`dropzone:${user.accType}`}
                  data-pa-page={`dropzone:feedback:${user.accType}`}
                  data-pa-click="feedback"
                  onClick={() => this.showFeedBackForm()}
                >
                  <Message id="footer.feedback" />
                </a>
              </li>
            )}
          </ul>
          <div className="vx_globalFooter_secondary">
            <p className="vx_globalFooter-copyright">
              © 1999-{new Date().getFullYear()} PayPal, Inc.{' '}
              <Message id="footer.copyrightText" />.
            </p>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer
